// =============   product size guide popup  =============

(function() {
  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  let activePopup = null;
  let previousFocus = null;

  function openPopup(popup, trigger) {
    if (!popup) return;

    previousFocus = trigger || document.activeElement;
    activePopup = popup;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-popup-open');

    const focusables = getFocusableElements(popup);
    if (focusables.length) {
      setTimeout(() => focusables[0].focus(), 10);
    }
  }

  function closePopup(popup) {
    if (!popup) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-popup-open');

    if (previousFocus) previousFocus.focus();

    activePopup = null;
  }

  document.addEventListener('click', function(e) {
    const openBtn = e.target.closest('[data-popup-trigger]');
    if (openBtn) {
      const popupId = openBtn.getAttribute('data-popup-trigger');
      const popup = document.getElementById(popupId);
      openPopup(popup, openBtn);
      return;
    }

    const closeBtn = e.target.closest('[data-popup-close]');
    if (closeBtn) {
      const popup = closeBtn.closest('.product-popup-modal');
      closePopup(popup);
    }

    // Overlay click to close
    if (e.target.classList.contains('product-popup-modal')) {
      closePopup(e.target);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activePopup) {
      closePopup(activePopup);
    }
  });
})();